import { RouteProps } from "react-router-dom";
import PrivateRouter from "./PrivateRouter";

export default function PrivateRouteRequiredToken({ ...rest }: RouteProps): JSX.Element {
  const token = location.search.replace("?token=", "");

  return <PrivateRouter accessCondition={Boolean(token)} {...rest} />;
}
